export default __webpack_public_path__ + "static/media/16_mara_collins.eb3fc05c.jpg";